import api from "../services/api";

export const getProductGroups = (params) => {
  return new Promise((resolve, reject) => {
    api
      .get(`feedback/product_groups`, { params: params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getProduct = (params) => {
  return new Promise((resolve, reject) => {
    api
      .get(`product/${params.productId}`, { params: params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getProducts = (params) => {
  return new Promise((resolve, reject) => {
    api
      .get(`feedback/products`, { params: params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getProductsId = (params) => {
  return new Promise((resolve, reject) => {
    api
      .get(`/product/source/${params.eId}`, { params: params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getModuleIdFromProduct = (params) => {
  return new Promise((resolve, reject) => {
    api
      .get(`/modules/product/${params.eId}`, { params: params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

